export const getShouldHideWelcomePageCloseButton = ({
  usePillLauncher,
  isUngatedForUpdatedLauncher,
  recommendedQuestionsCount
}) => {
  if (!usePillLauncher) {
    return true;
  }
  if (isUngatedForUpdatedLauncher) {
    return true;
  }
  if (recommendedQuestionsCount === 0) {
    return true;
  }
  return false;
};